import * as React from 'react'
//import { Grid, Col, Row } from 'react-bootstrap';
import {Redirect} from 'react-router'



export const NoMatch = (props: any) =>{
    if(window.localStorage["isLogged"]==="true")
        return (
                <div>   
                    <Redirect to={'/dashboard'} push/>    
                </div>)
    else
        return (
                <div>   
                    <Redirect to={'/login'} push/>    
                </div>)
}
   


// WEBPACK FOOTER //
// ./src/Routes/NoMatch.tsx